module.exports = __webpack_public_path__ + "img/twitter.578d9cf1.svg";